module.exports = __webpack_public_path__ + "static/media/insurance-sme.06990b81.svg";